/* unplugin-vue-components disabled */import script from "./cancelOrderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./cancelOrderModal.vue?vue&type=script&setup=true&lang=js"

import "./cancelOrderModal.vue?vue&type=style&index=0&id=2c123825&lang=scss"

const __exports__ = script;

export default __exports__